export const FETCH_AUDIT_LOGS_REPORT = "FETCH_AUDIT_LOGS_REPORT";
export const FETCH_AUDIT_LOGS_REPORT_SUCCESS =
  "FETCH_AUDIT_LOGS_REPORT_SUCCESS";
export const FETCH_AUDIT_LOGS_REPORT_FAILED = "FETCH_AUDIT_LOGS_REPORT_FAILED";

export const DOWNLOAD_AUDIT_LOGS_REPORT = "DOWNLOAD_AUDIT_LOGS_REPORT";
export const DOWNLOAD_AUDIT_LOGS_REPORT_SUCCESS =
  "DOWNLOAD_AUDIT_LOGS_REPORT_SUCCESS";
export const DOWNLOAD_AUDIT_LOGS_REPORT_FAILED =
  "DOWNLOAD_AUDIT_LOGS_REPORT_FAILED";
